import { render, staticRenderFns } from "./DepartmentDetailModal.vue?vue&type=template&id=32997ae6&scoped=true&"
import script from "./DepartmentDetailModal.vue?vue&type=script&lang=js&"
export * from "./DepartmentDetailModal.vue?vue&type=script&lang=js&"
import style0 from "./DepartmentDetailModal.vue?vue&type=style&index=0&id=32997ae6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32997ae6",
  null
  
)

export default component.exports